module.exports = __webpack_public_path__ + "assets/f451dc8ddfa113239ed0cbee5bed6936.svg";